/**
 *微信接口的promise版本
 *
 * @param {*} api
 * @param {*} options
 * @returns
 */
function promisifyWxSdk(api, options) {
    return new Promise((resolve, reject) => {
        const fn = wx[api]
        if (!fn) {
            reject(Error('方法不存在'))
        } else {
            fn({
                ...options,
                success: res => {
                    resolve(res)
                },
                fail: error => {
                    reject(Error(error.errMsg))
                }
            })
        }
    })
}

//proxy
function proxyApi(module, target, data, freeLogin = 0) {
    return new Promise((resolve, reject) => {
        window.cw(
            'ajax',
            'proxy',
            data => {
                if (data.result && data.result.error) {
                    reject(data.result.error)
                } else {
                    resolve(data.result)
                }
            },
            reject,
            {
                module,
                target,
                data,
                freeLogin
            }
        )
    })
}
export { promisifyWxSdk, proxyApi }
